import { useState, type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';
import { useT } from '@/lib/i18n';
import { cn } from '@/lib/utils';

/** A collapsible card in the side columns: "About this contact", "Deals (2)"… */
export function RecordSection({
  title,
  count,
  action,
  defaultOpen = true,
  children,
}: {
  title: string;
  count?: number;
  action?: ReactNode;
  defaultOpen?: boolean;
  children: ReactNode;
}) {
  const t = useT();
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="rounded-lg border bg-card">
      <div className="flex items-center gap-2 px-4 py-3">
        <button type="button" onClick={() => setOpen((value) => !value)} className="flex min-w-0 flex-1 items-center gap-1.5 text-start">
          <ChevronDown className={cn('h-4 w-4 shrink-0 transition-transform', !open && '-rotate-90 rtl:rotate-90')} />
          <span className="truncate text-sm font-bold">
            {t(title)}
            {count !== undefined && <span className="font-semibold text-muted-foreground"> ({count})</span>}
          </span>
        </button>
        {action}
      </div>
      {open && <div className="border-t px-4 pb-3 pt-1">{children}</div>}
    </section>
  );
}
